










































































































































































import { Component, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { InputDatePicker } from '@/components/molecules/InputDatePicker'
import { InputCode } from '@/components/molecules/InputCode'
import { InputCodeDonor } from '@/components/molecules/InputCodeDonor'
import { InputCodeTrader } from '@/components/molecules/InputCodeTrader'
import { InputUserId } from '@/components/molecules/InputUserId'

export interface InputEditAcceptedAndBudgetItem {
  acceptDate: {
    input: string
    errorMessage: string
  }
  acceptType: {
    input: string
    errorMessage: string
  }
  acceptPrice: {
    input: string
    errorMessage: string
  }
  listPrice: {
    input: string
    errorMessage: string
  }
  applicantUserId: {
    input: string
    errorMessage: string
  }
  traderCode: {
    input: string
    errorMessage: string
  }
  donorCode: {
    input: string
    errorMessage: string
  }
  budgetYear: {
    input: string
    errorMessage: string
  }
  budgetBranchCode: {
    input: string
    errorMessage: string
  }
  budgetDepartmentCode: {
    input: string
    errorMessage: string
  }
  budgetExpenseCode: {
    input: string
    errorMessage: string
  }
  equipType: {
    input: string
    errorMessage: string
  }
}

export const defaultInputEditAcceptedAndBudgetItem = (): InputEditAcceptedAndBudgetItem => ({
  acceptDate: {
    input: '',
    errorMessage: ''
  },
  acceptType: {
    input: '',
    errorMessage: ''
  },
  acceptPrice: {
    input: '',
    errorMessage: ''
  },
  listPrice: {
    input: '',
    errorMessage: ''
  },
  applicantUserId: {
    input: '',
    errorMessage: ''
  },
  traderCode: {
    input: '',
    errorMessage: ''
  },
  donorCode: {
    input: '',
    errorMessage: ''
  },
  budgetYear: {
    input: '',
    errorMessage: ''
  },
  budgetBranchCode: {
    input: '',
    errorMessage: ''
  },
  budgetDepartmentCode: {
    input: '',
    errorMessage: ''
  },
  budgetExpenseCode: {
    input: '',
    errorMessage: ''
  },
  equipType: {
    input: '',
    errorMessage: ''
  }
})

const PRICE_PREFIX: string = '￥'

@Component({
  components: {
    InputUserId,
    InputCodeTrader,
    InputCodeDonor,
    InputDatePicker,
    InputCode
  }
})
export default class CollectionEditCollectionAcceptedAndBudgetInfo extends ComponentVue {
  @PropSync('input', {
    type: Object,
    required: true
  })
  inputItem!: InputEditAcceptedAndBudgetItem

  get acceptPriceMask(): string {
    return '#'.repeat(7)
  }

  get listPriceMask(): string {
    return '#'.repeat(7)
  }

  get budgetYearMask(): string {
    return '#'.repeat(4)
  }

  get pricePrefix(): string {
    return PRICE_PREFIX
  }

  existsErrorMessage(errorMessage: string): boolean {
    return errorMessage !== ''
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }
}
